import { EntityFlagAvatar } from "v2/components/onboarding/EntityFlagAvatar";
import { CompanyOverview } from "./brandOverview.types";
import { CompanyMissingCallout } from "./CompanyMissingCallout";
import { EMPTY_FIELD } from "./constants";
import { PanelField } from "./PanelField";

type CompanyOverviewPanelProps = {
  company: CompanyOverview;
  onViewMissing: () => void;
};

// small country chip (flag + name) — used only in this panel
const CountryChip = ({ code, name }: { code: string; name: string }) => {
  return (
    <span className="t-flex t-items-center t-gap-1.5 t-rounded-md t-bg-surface-grey t-px-2 t-py-1 t-text-body-sm t-text-text-60">
      <EntityFlagAvatar countryCode={code} size="xs" shape="circle" />
      {name}
    </span>
  );
};

export const CompanyOverviewPanel = ({
  company,
  onViewMissing,
}: CompanyOverviewPanelProps) => {
  const showCountry = !company.hasSiblings && Boolean(company.countryName);
  const websiteHref = `https://${company.website}`;

  return (
    <div className="t-flex t-h-full t-flex-1 t-flex-col t-gap-5">
      <div className="t-flex t-flex-col t-gap-1">
        <span className="t-text-caption t-font-light t-uppercase t-tracking-wide t-text-neutral-50">
          Brand overview
        </span>
        <span className="t-text-subtitle t-font-medium t-text-text-100">
          {company.name}
        </span>
      </div>

      <PanelField label="Website">
        {company.website ? (
          <a
            href={websiteHref}
            target="_blank"
            rel="noreferrer"
            className="t-text-body t-text-purple t-no-underline"
          >
            {company.website}
          </a>
        ) : (
          EMPTY_FIELD
        )}
      </PanelField>

      {showCountry && (
        <PanelField label="Country">{company.countryName}</PanelField>
      )}

      {company.operatingCountries.length > 0 && (
        <PanelField label="Countries operating in">
          <div className="t-mt-1 t-flex t-flex-wrap t-gap-2">
            {company.operatingCountries.map((country) => (
              <CountryChip
                key={country.code}
                code={country.code}
                name={country.name}
              />
            ))}
          </div>
        </PanelField>
      )}

      <div className="t-mt-auto">
        <CompanyMissingCallout onView={onViewMissing} />
      </div>
    </div>
  );
};
